import PropTypes from 'prop-types';

import { glossaryListType } from 'humanity/components/glossaryList';
import { simpleMastheadType } from 'humanity/sections/simpleMasthead';

export const retirementGlossaryProps = {
  sections: PropTypes.arrayOf(simpleMastheadType).isRequired,
  list: glossaryListType.isRequired,
};

export const retirementGlossaryType = PropTypes.shape({});
